import CredentialWizard from '@/components/credentials/CredentialWizard';
import ModalV2 from '@/components/ModalV2';
import { FiX } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2';
import { getCredentialById } from '@/redux/actions/gravityActions';
import { setModalState } from '@/redux/actions/uiActions/modalActions';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import selectors from '@/redux/selectors/selectors';
import { modal } from '@/redux/selectors/uiSelectors';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

const CredentialModal = () => {
  const modalState = useSelector(memoizeSelector('modal:credential', (state) => modal(state, 'credential')));
  const companyId = useSelector(selectors.companyId);
  const show = modalState?.open;
  const credentialId = modalState?.credentialId;
  const wizardRef = useRef();

  const handleClose = () => {
    setModalState('credential', { open: false });
    getCredentialById(credentialId, { secrets: true, companyId, forceUpdate: true });
  };

  const handleHide = async () => {
    if (wizardRef?.current?.saveAndClose) {
      await wizardRef.current.saveAndClose();
    } else {
      handleClose();
    }
  };

  return (
    <ModalV2 maxWidth={'450px'} maxHeight={'98svh'} className={'credential-modal'} show={show} onHide={handleHide} noHeader noFooter centered>
      {show && <CredentialWizard ref={wizardRef} credentialId={credentialId} onClose={handleClose} />}
      <div role={'button'} className={'close-button'} onClick={handleHide} data-title={'Close'}>
        <IconV2 icon={FiX} />
      </div>
    </ModalV2>
  );
};

export default CredentialModal;
